import { createActions, createReducer } from 'reduxsauce'
import Immutable from 'seamless-immutable'

export const INITIAL_STATE = Immutable({
  fireOrders: {},
  hasuOrders: [],
  diffOrders: {},
  orderLoading: false,
  orderLoaded: false,
  orderError: {},

  fireItems: {},
  hasuItems: [],
  diffItems: {},
  itemLoading: false,
  itemLoaded: false,
  itemError: {},

  startAt: null,
  endAt: null,
})

const { Types, Creators } = createActions({
  getOrders: ['startAt', 'endAt'],
  setOrders: ['data'],
  clearOrders: null,
  setOrderError: ['error'],
  reuploadOrders: ['orderIds'],

  getItems: ['startAt', 'endAt'],
  setItems: ['data'],
  setItemError: ['error'],
})

export const reuploadOrderReducer = state => {
  return state.set('orderLoading', true)
}

export const clearOrderReducer = state =>
  state
    .set('orderLoading', false)
    .set('orderLoaded', false)
    .set('diffOrders', {})
    .set('hasuOrders', [])
    .set('fireOrders', {})

export const getOrderReducer = (state, { startAt, endAt }) => state.set('orderLoading', true)

export const setOrderReducer = (state, { data: { hasuraData, firebaseData, diffOrders } }) => {
  return state
    .set('orderLoading', false)
    .set('orderLoaded', true)
    .set('hasuOrders', hasuraData)
    .set('fireOrders', firebaseData)
    .set('diffOrders', diffOrders)
}

export const setOrderErrorReducer = (state, { error }) =>
  state
    .set('orderError', error)
    .set('orderLoaded', false)
    .set('orderLoading', false)

export const getItemReducer = state => state.set('itemLoading', true)

export const setItemReducer = (state, { data: { hasuraData, firebaseData, diffItems } }) => {
  return state
    .set('itemLoading', false)
    .set('itemLoaded', true)
    .set('fireItems', firebaseData)
    .set('hasuItems', hasuraData)
    .set('diffItems', diffItems)
}

export const setItemErrorReducer = (state, { error }) =>
  state
    .set('itemError', error)
    .set('itemLoaded', false)
    .set('itemLoading', false)

export const hasuraDataValidationReducer = createReducer(INITIAL_STATE, {
  [Types.REUPLOAD_ORDERS]: reuploadOrderReducer,

  [Types.GET_ORDERS]: getOrderReducer,
  [Types.SET_ORDERS]: setOrderReducer,
  [Types.CLEAR_ORDERS]: clearOrderReducer,
  [Types.SET_ORDER_ERROR]: setOrderErrorReducer,

  [Types.GET_ITEMS]: getItemReducer,
  [Types.SET_ITEMS]: setItemReducer,
  [Types.SET_ITEM_ERROR]: setItemErrorReducer,
})

export const HasuraDataValidationTypes = Types
export default Creators



// WEBPACK FOOTER //
// ./src/reducers/hasuraDataValidationReducer.js